module.exports = __webpack_public_path__ + "static/media/boleta_factura.88281707.png";